import { Button, Card, List, Popconfirm } from "antd";
import Router from "../..";
import { useUserStore } from "../../../stores/userStore";
import { useEffect, useState } from "react";
import { CATEGORY_MAPPING, CATEGORY_STYLES } from "../../utils/categories";

export const InfluencerInvitations = () => {
  const { loadUserInfo, userInfo } = useUserStore();
  const [invitedAgencies, setInvitedAgencies] = useState([]);

  const fetchInvitedAgencies = async () => {
    const res = await Router.Api.getInvitedAgencies();
    const list = res?.result ?? [];
    setInvitedAgencies(list);
  };

  useEffect(() => {
    fetchInvitedAgencies();
  }, []);

  const handleAcceptInvitation = async (company_id) => {
    const res = await Router.Api.acceptAgencyInvitation(company_id);
    if (res) {
      await loadUserInfo();
      fetchInvitedAgencies();
    }
  };

  const handleLeaveAgency = async () => {
    const res = await Router.Api.leaveAgency();
    if (res) {
      await loadUserInfo();
    }
  };

  const renderInvitedHistoryCard = () => {
    const hasInvitations = invitedAgencies.length > 0;
    const hasAgency = userInfo?.agency_info;

    // 에이전시가 연결되어 있으면 연결된 에이전시 정보 표시
    if (hasAgency) {
      return (
        <Card
          title="담당 에이전시"
          className="w-full max-w-[600px] border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]"
        >
          <div className="mb-4">
            <div className="flex flex-row gap-2 items-center mb-4">
              <div className="text-2xl font-semibold">
                {userInfo.agency_info.company_name}
              </div>
              <span
                className="px-2 py-0.5 rounded-lg text-base"
                style={
                  CATEGORY_STYLES[userInfo.agency_info.industry] ||
                  CATEGORY_STYLES.etc
                }
              >
                {CATEGORY_MAPPING[userInfo.agency_info.industry] || "기타"}
              </span>
            </div>
            <div className="text-base text-[#999] bg-[#f5f5f5] p-3 rounded">
              현재 이 에이전시가 캠페인 제안, 지원, 초대 등 캠페인 관련 업무를
              대행하고 있으며, 모든 알림과 주요 커뮤니케이션은 이 에이전시를
              통해 진행됩니다.
            </div>
          </div>
          <div className="flex justify-end mt-8">
            <Popconfirm
              title="에이전시에서 나가시겠습니까?"
              onConfirm={handleLeaveAgency}
              okText="나가기"
              cancelText="취소"
            >
              <Button danger size="small">
                나가기
              </Button>
            </Popconfirm>
          </div>
        </Card>
      );
    }

    // 초대받은 내역이 있으면 초대 내역 표시
    if (hasInvitations) {
      return (
        <Card
          title="초대받은 내역"
          className="w-full max-w-[600px] border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]"
        >
          <List
            dataSource={invitedAgencies}
            renderItem={(item) => (
              <List.Item
                actions={[
                  <Popconfirm
                    title="초대를 수락하시겠습니까?"
                    description={
                      <>
                        초대를 수락하면 해당 에이전시가
                        <br />
                        캠페인 제안, 지원, 초대 등 캠페인 관련 업무를 대행하게
                        되며,
                        <br />
                        모든 알림과 주요 커뮤니케이션은 에이전시를 통해
                        진행됩니다.
                        <br />
                        또한, 다른 에이전시의 초대는 모두 거절됩니다.
                      </>
                    }
                    onConfirm={() => handleAcceptInvitation(item.company_id)}
                    okText="수락"
                    cancelText="취소"
                  >
                    <Button type="primary" size="small">
                      수락
                    </Button>
                  </Popconfirm>,
                ]}
              >
                <div>
                  <div>
                    <strong>{`${item.company_name} 에이전시`}</strong>
                    에서 당신을 초대하였습니다.
                  </div>
                  <div className="text-[12px] text-[#999]">{`초대일: ${item.created_at}`}</div>
                </div>
              </List.Item>
            )}
          />
        </Card>
      );
    }

    // 둘 다 없으면 빈 상태 표시
    return (
      <Card
        title="초대받은 내역"
        className="w-full max-w-[600px] border border-[#d9d9d9] rounded-[10px] bg-white shadow-[0_2px_6px_rgba(0,0,0,0.1)] mb-[30px]"
      >
        <div className="p-5 text-center text-[#999]">
          초대받은 내역이 없습니다.
        </div>
      </Card>
    );
  };

  return (
    <div>
      <h2 className="md:text-4xl text-3xl font-bold">초대 목록</h2>
      {userInfo?.user_info?.user_type === "influencer" && (
        <div className="w-full max-w-[600px]">{renderInvitedHistoryCard()}</div>
      )}
    </div>
  );
};
